import 'dayjs/locale/hu'
import { Dayjs } from 'dayjs'

const weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ')

const hu = {
  calendar: {
    sameDay: '[ma] LT[-kor]',
    nextDay: '[holnap] LT[-kor]',
    nextWeek: function (now: Dayjs) {
      return now.format('[' + weekEndings[now.day()] + '] LT[-kor]')
    },
    lastDay: '[tegnap] LT[-kor]',
    lastWeek: function (now: Dayjs) {
      return now.format('[múlt] [' + weekEndings[now.day()] + '] LT[-kor]')
    },
    sameElse: 'L'
  }
}

export default hu
